/*
 * Project: BookingEngine
 * Module: components/booking/RateSelector.js
 * vim:ft=javascript.jsx:
 */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Btn from '../../ds/atoms/btn/base';
import { getLangValue } from '../../../utils/Generic';
import LoyaltyUserRate from '../../loyalty/LoyaltyUserRate';
import Select from '../../common/Select';
import { DEVICES } from '../../../actions/Booking';
import RoomAmounts from './RoomAmounts';

class RateSelector extends (Select) {
  constructor(props) {
    super(props);

    this.state = {
      selectedDetailCode: null,
    };
  }

  renderLoyaltyUserRate(selectedBoard) {
    if (this.props.agentCode !== '' && this.props.agentSell === 'true') {
      return null;
    }
    if (this.props.memberInfo != null) {
      return (
        <LoyaltyUserRate
          board={selectedBoard}
          showJoinLoyaltyMessage={false}
        />
      );
    }
    return null;
  }

  render() {
    const {
      options, selectId, selectedValue, detailsField, lang, hotel,
      selectedBoard, currency, lastRequestedInfo,
    } = this.props;
    const rateSelectedMarginClassToUse = 'rateSelectedMargin';
    /*if(this.props.hotel.show_original_price) {
      rateSelectedMarginClassToUse = 'rateSelectedMarginShowOriginalPrice';
    }*/
    //Se pidió que no se mostrara la cantidad anterior acá
    let adjustRatePositionClassToUse = 'adjustRatePosition';
    if (this.props.isMobile) {
      adjustRatePositionClassToUse = 'adjustRatePositionMobile';
      /*if(this.props.hotel.show_original_price) {
        adjustRatePositionClassToUse = 'adjustRatePositionShowOriginalPriceMobile'
      }*/
      //Se pidió que no se mostrara la cantidad anterior acá
    } else {
      /*if(this.props.hotel.show_original_price) {
        adjustRatePositionClassToUse = 'adjustRatePositionShowOriginalPrice'
      }*/
      //Se pidió que no se mostrara la cantidad anterior acá
    }
    return (
      <ul className={'ml-2 w-100'}>
        {options.map((option, idx) => {
          const id = `RadioSelect_${selectId}_${idx}`;
          const isSelected = option.code === selectedValue.code;
          return (
            <li key={id} className={`${this.props.isMobile
              ? 'card-contentMobile-li' : ''} flex justify-between flex-wrap h-10 ${isSelected
              && (this.props.isLoyaltyUserLoggedIn || this.props.selectedStatus === 'becomeMember')
              ? rateSelectedMarginClassToUse : ''}`}>
              <div className={`flex items-center font-semibold ${this.props.isMobile
                ? 'fontRatesMobile' : 'text-base'}`}>
                <Btn
                  className={` font-sans ${isSelected ? 'text-primary' : ''}`}
                  onClick={this.onOptionSelected(option)}
                >
                  <span className={`radio-dot ${isSelected ? 'active' : ''} mr-2`}/>
                  {getLangValue(option, lang, 'name')}
                </Btn>
                {this.renderShowDetails(detailsField, option)}
              </div>
              {isSelected
              && <RoomAmounts
                amounts={selectedBoard.amount}
                currency={currency}
                showOriginal={hotel.show_original_price}
                nights={lastRequestedInfo.nights}
                extraClass={`flex ${currency.code === 'MXN' ? 'MXN' : ''} ${currency.code === 'USD' ? 'USD' : ''}`}
                showDescription={false}
                showFinalAmount={false}
                coinsApplied={this.props.coinsApplied}
                showAmounts={this.props.isMobile ? 'PER_NIGHT' : 'BOTH'}
                roundAmount={!!this.props.isMobile}
                forceCrossedAmount={(this.props.isLoyaltyUserLoggedIn
                  || this.props.selectedStatus === 'becomeMember') ? hotel.show_original_price : false}
                doNotShowCurrent={(this.props.isLoyaltyUserLoggedIn
                  || this.props.selectedStatus === 'becomeMember') ? hotel.show_original_price : false}
              />}
              {isSelected
                && <div className={`${adjustRatePositionClassToUse}`}>
                    {this.renderLoyaltyUserRate(selectedBoard)}
                    { this.props.hotel.percentage_total_taxes > 0
                      && <small className='tarifaSinImpuestosText'>{this.context.t('Rate without taxes')}</small>}
                    { this.props.hotel.percentage_total_taxes === 0
                      && <small className='tarifaSinImpuestosText'>{this.context.t('Taxes included')}</small>}
                </div>
              }
            </li>
          );
        })}
      </ul>
    );
  }
}

RateSelector.contextTypes = {
  t: PropTypes.func.isRequired,
};

RateSelector.propTypes = {
  hotel: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  lang: PropTypes.string.isRequired,
  detailsField: PropTypes.string.isRequired,
  currency: PropTypes.object.isRequired,
  selectId: PropTypes.string.isRequired,
  selectedValue: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedBoard: PropTypes.object.isRequired,
  coinsApplied: PropTypes.number.isRequired,
};

RateSelector.defaultProps = {
  selectedValue: {},
  extraClass: '',
};

export default connect(((state) => ({
  memberInfo: state.loyalty.memberInfo,
  selectedStatus: state.loyalty.selectedStatus,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email
    && !(state.bookingFormState.agentCode !== ''
    && state.bookingFormState.agentSell === 'true') : false,
  hotel: state.booking.hotel,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
})))(RateSelector);
